import { gql } from '@apollo/client'
import { liveArticleEventData, liveArticleListData } from './'

export const GET_LIVE_BLOGS = gql`
  query ListLiveBlogContent($input: listLiveBlogContentFrontInput!) {
    listLiveBlogContentFront(input: $input) {
      ${liveArticleListData}
      ${liveArticleEventData}
    }
  }
`
